import type { LoaderProps } from '@wix/da-ds/pkg/Loader';

export type UploaderVariant = 'originals' | 'arts-and-crafts';

interface VariantConfig {
  uploadingLoaderState: LoaderProps['state'];
  uploadingTitleKey: string;
  emptyStateTitleKey: string;
  emptyStateSubtitleKey: string;
  emptyLoaderState?: LoaderProps['state'];
  emptyStateClass?: string;
}

export const VARIANT_CONFIG: Record<UploaderVariant, VariantConfig> = {
  originals: {
    uploadingLoaderState: 'painting_brush',
    uploadingTitleKey: 'uploadZone.progress.title.originals',
    emptyStateClass: 'originals-loader',
    emptyStateTitleKey: 'originalDeviationPopup.form.coverImage.title',
    emptyStateSubtitleKey: 'originalDeviationPopup.form.coverImage.subtitle',
  },
  'arts-and-crafts': {
    uploadingLoaderState: 'scissors',
    uploadingTitleKey: 'uploadZone.progress.title.artsAndCrafts',
    emptyLoaderState: 'scissors',
    emptyStateTitleKey: 'artsAndCraftsDeviationPopup.form.coverImage.title',
    emptyStateSubtitleKey: 'artsAndCraftsDeviationPopup.form.coverImage.subtitle',
  },
};
